import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c9293da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed bg-gray-500 bg-opacity-40 inset-0 z-10 overflow-y-auto" }
const _hoisted_2 = { class: "min-h-screen text-center flex items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "inline-block h-full align-middle"
}, " ​ ", -1))
const _hoisted_4 = { class: "h-full" }
const _hoisted_5 = { class: "text-sm mt-2 h-full text-gray-500 overflow-y-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    show: _ctx.show,
    appear: "",
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        as: "div",
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal(1)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0" })
                ]),
                _: 1
              }),
              _hoisted_3,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.classes, "inline-block w-full overflow-y-auto max-w-md p-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl"])
                  }, [
                    _createVNode(_component_DialogTitle, {
                      as: "div",
                      class: "text-lg font-medium leading-6 text-gray-900"
                    }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "header", {}, undefined, true)
                      ]),
                      _: 3
                    }),
                    _createElementVNode("div", {
                      class: _normalizeClass([{'pb-modal':_ctx.size === 'screen'}, "h-full"])
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                        ])
                      ])
                    ], 2),
                    _createElementVNode("div", {
                      class: _normalizeClass([{'fixed bottom-0 py-4 left-0 right-0 bg-white shadow-md border-t border-gray-100':_ctx.size === 'screen'}, "mt-4"])
                    }, [
                      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                    ], 2)
                  ], 2)
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}